<template>

    <CobaltDashboard 
        :info="null" 
        :company="company" 
        :project="project" 
        :withFilterBar="false" 
        contentClasses="single ps-0 pe-0" 
        @switchMode="switchDashboardMode" 
        @showMod="showMod"
        @refresh="getPrimaryInfo"
    >

        <div class="np-home-row" :class="{'np-pb-0' : this.dashboardMode == 'canban'}">
            <div class="np-group np-tabs-column np-pr-4" :class="this.commandTabsMode">
                <button 
                    class="np-btn np-mb-4" 
                    :class = "this.dashboardMode == 'dashboard' ? 'np-btn-secondary active' : 'np-btn-outline'"
                    @click="switchDashboardMode('dashboard')">
                    <svg class="icon"><use href="@/assets/images/icons/dashboard.svg#icon"></use></svg>
                    <span>{{ $t('UI.dashboard.dashboard') }}</span>
                </button>
                <button 


                    class="np-btn np-mb-4" 
                    :class = "this.dashboardMode == 'canban' ? 'np-btn-secondary active' : 'np-btn-outline'"
                    @click="switchDashboardMode('canban')">
                    <svg class="icon"><use href="@/assets/images/icons/table.svg#icon"></use></svg>
                    <span>{{ $t('UI.dashboard.canban') }}</span>
                </button>  
                <button 
                    class="np-btn np-mb-4" 
                    :class = "this.dashboardMode == 'calendar' ? 'np-btn-secondary active' : 'np-btn-outline'"
                    @click="switchDashboardMode('calendar')">
                    <svg class="icon"><use href="@/assets/images/icons/calendar.svg#icon"></use></svg>
                    <span>{{ $t('UI.dashboard.calendar') }}</span>
                </button> 
                <button 
                    class="np-btn np-mb-4" 
                    :class = "this.dashboardMode == 'tasklist' ? 'np-btn-secondary active' : 'np-btn-outline'"
                    @click="switchDashboardMode('tasklist')">
                    <svg class="icon"><use href="@/assets/images/icons/list2.svg#icon"></use></svg>
                    <span>{{ $t('UI.dashboard.list') }}</span>
                </button>  
                <button 
                    class="np-btn np-mb-4" 
                    :class = "this.dashboardMode == 'fileslist' ? 'np-btn-secondary active' : 'np-btn-outline'"
                    @click="switchDashboardMode('fileslist')">
                    <svg class="icon"><use href="@/assets/images/icons/folder2.svg#icon"></use></svg>
                    <span>{{ $t('UI.dashboard.files') }}</span>
                </button>     
                <button 
                    class="np-btn np-mb-4" 
                    :class = "this.dashboardMode == 'diagram' ? 'np-btn-secondary active' : 'np-btn-outline disabled'">
                    <svg class="icon"><use href="@/assets/images/icons/diagram.svg#icon"></use></svg>
                    <span>{{ $t('UI.dashboard.diagram') }}</span>
                </button> 
                <button 
                    class="np-btn np-mb-4" 
                    :class = "this.dashboardMode == 'team' ? 'np-btn-secondary active' : 'np-btn-outline disabled'">
                    <svg class="icon"><use href="@/assets/images/icons/team.svg#icon"></use></svg>
                    <span>{{ $t('UI.dashboard.team') }}</span>
                </button>  
                <button 
                    class="np-btn np-mb-4" 
                    :class = "this.dashboardMode == 'archive' ? 'np-btn-secondary active' : 'np-btn-outline'"
                    @click="switchDashboardMode('archive')">
                    <svg class="icon"><use href="@/assets/images/icons/archive2.svg#icon"></use></svg>
                    <span>{{ $t('UI.dashboard.archive') }}</span>
                </button> 
                <button 
                    @click="switchCommandTabsMode"
                    class="np-btn np-btn-outline switcher np-mb-4">
                    <svg><use href="@/assets/images/icons/collapse.svg#icon"></use></svg>
                </button>                  
            </div> 

            <div class="np-group np-flex-1">
                <ProjectDashboard
                    :project="project"
                    :tasks="this.tasks"
                    :statuses="this.listStat"
                    :priorityValues="this.priorityValues"
                    :users="this.projectUsers"
                    :projectComments="this.commentsList"
                    @showModTask="showModTask"
                    @showModProject="requestProjectEdit"
                    v-if="this.dashboardMode == 'dashboard'"
                />

                <div v-if="this.dashboardMode == 'canban'" class="np-group np-group-column">
                    <div class="np-group np-pb-4">
                        <div class="np-group justify-items-start">
                            <button class="np-btn np-btn-primary-lighter np-mr-2" @click="this.showMod()">
                                <svg class="icon"><use href="@/assets/images/icons/plus.svg#icon"></use></svg>    
                                {{ $t("UI.addStatus") }}
                            </button>  
                            <div class="np-field-group np-with-icon-right me-2">
                                <input type="text" class="np-text-input np-outline" />
                                <svg class="field-icon at-left"><use href="@/assets/images/icons/search.svg#icon"></use></svg>
                            </div>                                                      
                            <button class="np-btn np-outline np-mr-2">
                                <svg><use href="@/assets/images/icons/filter.svg#icon"></use></svg>
                            </button>
                            <button class="np-btn np-outline np-mr-1">
                                <svg><use href="@/assets/images/icons/sorting.svg#icon"></use></svg>
                            </button>
                        </div>
                    </div>  
                    
                    <div class="np-group np-flex-1"> 
                        
                        <VueDraggable v-model="listStat" class="np-group np-scroll-x" animation="200" :force-fallback="true" :scroll-sensitivity="200" @end="onEnd">
                            <div class="np-canban-column-wrapper" v-for="elemStat in listStat" :key="elemStat.id">
                                <div class="np-canban-column">
                                    <div class="np-canban-column-header"
                                        :style="{ 'border-color': elemStat.color != '#000000' ? elemStat.color : null }"
                                    >
                                        <span class="np-bullet np-mr-2" :style="{ 'background-color': elemStat.color != '#000000' ? elemStat.color : null }"></span>
                                        <h6 class="np-header3 np-group align-items-center np-flex-1"><span class="np-font-ellipsis">{{ elemStat.title }}</span> <span class="np-badge-s np-inactive np-ml-1" v-if="tasks[elemStat.id] && tasks[elemStat.id].length > 0">{{`0${tasks[elemStat.id].length}`.slice(-2)}}</span></h6>
                                        <div class="np-group np-overflow-visible np-ml-2">
                                            <!--
                                            <button type="button" class="np-btn np-btn-link np-mr-2" @click="showModTask(0, elemStat.id)">
                                                <svg><use href="@/assets/images/icons/plus2.svg#icon"></use></svg>
                                            </button>
                                            -->
                                            <div class="dropdown">
                                                <button class="np-btn np-btn-link" :id="'taskDropdownMenuLink' + elemStat.id" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <svg><use href="@/assets/images/icons/dots-vertical.svg#icon"></use></svg>
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu" :aria-labelledby="'taskDropdownMenuLink' + elemStat.id">
                                                    <li class="dropdown-item"><button type="button" class="btn btn-link btn-sm me-2 text-body-tertiary"
                                                        @click="showMoveStatus(elemStat.id)"><font-awesome-icon
                                                            :icon="['fas', 'sort']" /> {{ $t("UI.moveStatus") }}</button></li>
                                                    <li class="dropdown-item"><button type="button" class="btn btn-link btn-sm me-2 text-body-tertiary"
                                                        @click="showMod(elemStat.id)"><font-awesome-icon
                                                            :icon="['fas', 'pencil']" /> {{ $t("UI.changeStatus") }}</button></li>
                                                    <li class="dropdown-item"><button type="button" class="btn btn-link btn-sm text-body-tertiary"
                                                        @click="showDel(2, elemStat.id)"><font-awesome-icon
                                                            :icon="['fas', 'trash']" /> {{ $t("UI.deleteStatus") }}</button></li>
                                                </ul>
                                            </div>                                            
                                        </div>
                                    </div>
                                    <div class="np-canban-column-subheader">
                                        <SimpleTaskForm :taskData="this.createNewTask" :statusId="elemStat.id" @refresh="updTstts" @scrollTop="doScrollTop"/>
                                    </div>
                                    <div class="np-canban-column-body pt-1 pb-2">  
                                        <h6 class="mb-0 p-3 text-center" v-if="tasks[elemStat.id].length == 0">{{ $t("message.noRecordsAvailable") }}</h6>
                                        <SimpleBar data-simplebar-auto-hide="true" style="min-height: 100%; max-height: 100%; overflow-y: auto;" :ref="`scrollbarRef${elemStat.id}`">
                                            <VueDraggable 
                                                class="drop-zone" 
                                                v-model="tasks[elemStat.id]" 
                                                animation="200"  
                                                :force-fallback="true" 
                                                :scroll-sensitivity="200" 
                                                group="tasks" 
                                                @end="onEnd"
                                                @drag="(e) => handleDrag(e, elemStat.id)">
                                                <TaskCard
                                                    v-for="elemTask in tasks[elemStat.id]"
                                                    :key="elemTask.id"
                                                    :task="getPreparedTask(elemTask)"
                                                    :statusId="elemStat.id"
                                                    :statuses="listStat"
                                                    @showModTask="showModTask"
                                                    @showArch="showArch"
                                                    @showDel="showDel"
                                                    @showMoveTo="showMoveTo"   
                                                    @refresh="updTstts"                             
                                                />
                                            </VueDraggable>
                                        </SimpleBar>
                                    </div>
                                </div>
                            </div>         
                        </VueDraggable>
                        
                    </div>
                </div>

                <Calendar
                    :tasks="this.tasks"
                    :priorityValues="this.priorityValues"
                    @showModTask="showModTask"
                    v-if="this.dashboardMode == 'calendar'"
                />

                <ProjectTaskList
                    :project="project"
                    :tasks="this.tasks"
                    :statuses="this.listStat"
                    :priorityValues="this.priorityValues"
                    :users="this.projectUsers"
                    @showModTask="showModTask"
                    @showModProject="requestProjectEdit"
                    v-if="this.dashboardMode == 'tasklist'"
                />
                
                <ProjectFilesList
                    :project="project"
                    :tasks="this.tasks"
                    :statuses="this.listStat"
                    :priorityValues="this.priorityValues"
                    :users="this.projectUsers"
                    @showModTask="showModTask"
                    @showModProject="requestProjectEdit"
                    @refresh="updTstts"
                    v-if="this.dashboardMode == 'fileslist'"
                />    
                <ProjectArchive
                    :project="project"
                    :data="this.archive"
                    :priorityValues="this.priorityValues"
                    :users="this.projectUsers"
                    @refresh="updTstts"
                    v-if="this.dashboardMode == 'archive'"
                />                               
            </div>
        </div>
    </CobaltDashboard>

    <BsModal  :modalID='modalID' modalPosition="center" ref="BsModal" class="cobalt-base-dialog">
        <template v-slot:header-left>
            <svg class="icon"><use href="@/assets/images/icons/cog.svg#icon"></use></svg> {{ modalTitle }}
        </template>
        <template v-slot:body>
            <div class="modal-body container ps-3 pe-3">
                <div class="row m-0 w-100 h-100">
                    <div class="col">
                        <form @submit.prevent="updateStatus(0)">                         
                            <div class="mb-3">
                                <label class="np-font-m np-f-medium mb-2">{{ $t("UI.name") }}</label>
                                <input type="text" class="form-control np-input" id="statusTitle" aria-describedby="loginHelp"
                                    v-model="datUpdateStatus.title">
                                <small id="loginHelp" class="form-text text-muted"></small>
                            </div>
                            <div class="mb-4">
                                <label class="np-font-m np-f-medium mb-2">{{ $t("UI.description") }}</label>
                                <textarea class="form-control np-input" id="statusDescription"
                                    v-model="datUpdateStatus.description"></textarea>
                            </div>
                            <div class="mb-1">
                                <label class="np-font-m np-f-medium mb-2">{{ $t("UI.backgroundColor") }}</label>
                            </div>
                            <div class="mb-4">
                                <div class="form-check form-check-inline" v-for="itemColor in colors">
                                    <input class="form-check-input color-check-input" type="radio" name="inlineRadioOptions"
                                        :checked="itemColor == datUpdateStatus.color" @change="chColor(itemColor)"
                                        id="inlineRadio1" :value="itemColor"
                                        :style="{ 'border-color': itemColor, 'border-width': itemColor == datUpdateStatus.color ? '12px' : '2px' }">
                                    <label class="form-check-label" for="inlineRadio1"></label>
                                </div>
                            </div>
                            <div v-if="datUpdateStatus.errorText != ''">
                                <p class="mt-2 mb-0 text-danger">{{ datUpdateStatus.errorText }}</p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal-footer p-3">
                <button type="button" class="np-btn np-danger px-4 me-1"
                    data-bs-dismiss="modal">{{ $t("UI.close") }}</button>
                <button type="button" class="np-btn np-success-filled px-4" @click="updateStatus(0)">{{ modalBtnOk
                    }}</button>
            </div>
        </template>
    </BsModal>

    <TskModal 
        :modalID='modalIDTsk' 
        :status="this.datUpdateStatus"
        :projectInfo="prInfo"
        :taskData="this.datUpdateTask"
        :projectUsers="this.projectUsers"
        modalPosition="right" 
        modalSize="modal-lg np-modal-lg"
        ref="TskModal" 
        
        @showMoveTo="showMoveTo"
        @showArch="showArch"
        @showDel="showDel"
        @closeModal="close"
        @refresh="updTstts">
    </TskModal>

    <MoveToModal :modalID='modalIMoveTo' modalSize="modal-sm" modalPosition="center" ref="MoveToModal" class="cobalt-base-dialog">
        <template v-slot:header-left>{{ $t("UI.task.moveTo") }}</template>
        <template v-slot:body>
            <div class="modal-body ps-3 pe-3">
                <p>{{ $t("UI.task.moveToConfirmation") }}</p>
                <ul class="cobalt-statuses__list">
                    <li class="cobalt-statuses__list-item" v-for="elemStat in listStat" :key="elemStat.id" @click="moveTo(elemStat.id)">
                        <span class="cobalt-bullet" :style="{ 'background-color': elemStat.color != '#000000' ? elemStat.color : null }"></span>
                        <span class="title">
                            {{ elemStat.title }} <sup class="tasks-count" v-if="tasks[elemStat.id] && tasks[elemStat.id].length > 0">{{`0${tasks[elemStat.id].length}`.slice(-2)}}</sup>
                        </span>
                    </li>
                </ul>
            </div>
            <div class="modal-footer ps-0 pe-0">
                <button type="button" class="btn btn-outline-secondary btn-sm"
                    data-bs-dismiss="modal">{{ $t("UI.close") }}
                </button>
            </div>
        </template>
    </MoveToModal>   

    <RoleModal :modalID='modalRole.id' modalSize="modal-md" modalPosition="center" ref="RoleModal" class="cobalt-base-dialog">
        <template v-slot:header-left>
            <div class="d-dlex">
                <h2 class="mb-0">{{ modalRole.title }}</h2>
            </div>
        </template>
        <template v-slot:body>
            <div class="modal-body">
                <div v-if="prInfo != null">
                    <RoleProject v-if="modalRole.isProject" :info='prInfo'></RoleProject>
                    <RoleStatus v-else :info='prInfo'></RoleStatus>
                </div>
            </div>
            <div class="modal-footer ps-0 pe-0">
                <button type="button" class="btn btn-outline-secondary btn-sm"
                    data-bs-dismiss="modal">{{ $t("UI.close") }}</button>
            </div>
        </template>
    </RoleModal> 

    <MoveStatusModal modalID="modalMoveStatus" modalSize="modal-md" modalPosition="center" ref="MoveStatusModal" class="cobalt-base-dialog">
        <template v-slot:header-left>
            <div class="d-dlex">
                <h2 class="mb-0">{{ $t("UI.moveStatus") }}</h2>
            </div>
        </template>
        <template v-slot:body>
            <div class="modal-body ps-3 pe-3">
                <p class="p-1 pb-4">{{ $t("message.sortingColumns") }}</p>
                <VueDraggable v-model="listStat" class="np-group np-group-column np-scroll-y" animation="200" :force-fallback="true" :scroll-sensitivity="200" @end="onEnd">                  
                    <div class="inMoveStatusWrapper pb-2" v-for="elemStat in listStat" :key="elemStat.id">
                        <div class="np-btn">
                            <span class="np-bullet np-mr-2" :style="{ 'background-color': elemStat.color != '#000000' ? elemStat.color : null }"></span>
                            <h6 class="np-header3 np-group align-items-center np-flex-1"><span class="np-font-ellipsis">{{ elemStat.title }}</span></h6>
                        </div>
                    </div>
                </VueDraggable>
            </div>
            <div class="modal-footer p-3">
                <button type="button" class="np-btn np-danger px-4 me-1"
                    data-bs-dismiss="modal">{{ $t("UI.close") }}</button>
            </div>
        </template>
    </MoveStatusModal>     
    
    <ProjectModal modalID="modalProjectNewID" @refresh="getPrimaryInfo" ref="projectModal" />  
</template>

<script>

import Navbar from "@/views/board/Navbar.vue"
import BsModal   from "@/components/modals/BsModal.vue"
import MoveToModal from "@/components/modals/BsModal.vue"
import MoveStatusModal from "@/components/modals/BsModal.vue"
import RoleModal from "@/components/modals/BsModal.vue"
import TskModal  from "@/components/modals/TaskModal.vue"
import TaskCard  from "@/components/TaskCard.vue" 
import TaskCardEvent  from "@/components/TaskCardEvent.vue" 
import CobaltDashboard from "@/components/dashboard/CobaltDashboard.vue"
import CobaltProfile   from "@/components/dashboard/parts/CobaltProfile.vue"
import CobaltPerformer from "@/components/dashboard/parts/CobaltPerformer.vue"
import CobaltProfilesList from "@/components/dashboard/parts/CobaltProfilesList.vue"
import ProjectDashboard from "@/components/dashboard/project/Dashboard.vue"
import ProjectTaskList from "@/components/dashboard/project/TaskList.vue"
import ProjectFilesList from "@/components/dashboard/project/FilesList.vue"
import ProjectArchive from "@/components/dashboard/project/Archive.vue"
import SimpleTaskForm from "@/components/dashboard/parts/CobaltSimpleTaskForm.vue"
import ProjectModal from "@/components/modals/ProjectModal.vue"
import RoleProject from "@/views/user/RoleProject.vue"
import RoleStatus  from "@/views/user/RoleStatus.vue"
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';
import Multiselect from 'vue-multiselect'
import { ref } from 'vue'
import { VueDraggable } from 'vue-draggable-plus'
import { mapGetters, mapActions } from 'vuex'
import { localeDate, eventDate, nameColor, priorityValues } from '@/utils/format'
import { PerfectScrollbar } from "vue3-perfect-scrollbar"
import Calendar from "@/components/dashboard/project/Calendar.vue"
import { confirm } from "@/utils/confirmation.js"

import SimpleBar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';

export default {
    components: {
        Navbar,
        BsModal,
        MoveToModal,
        MoveStatusModal,
        TskModal,
        VueDraggable,
        DatePicker,
        Multiselect,
        RoleModal,
        RoleProject,
        RoleStatus,
        TaskCard,
        TaskCardEvent,
        CobaltDashboard,
        CobaltProfile,
        CobaltPerformer,
        CobaltProfilesList,
        ProjectDashboard,
        ProjectTaskList,
        ProjectFilesList,
        ProjectArchive,
        SimpleTaskForm,
        Calendar,
        ProjectModal,
        SimpleBar
    },
    data() {
        return {
            dashboardMode: 'dashboard',
            commandTabsMode: 'expanded',
            project: {
                id: 0,
                name: '',
                description: '',
                date_create: null,
                date_update: null,
                date_planned_start: null,
                date_planned_end: null,
                company_id: null,
                budget: null
            },
            company: null,
            prInfo: {
                id: 0,
                title: '',
                activeUser: null
            },
            statusInfo: null,
            listStat: [],
            modalID: 'modalNewStatus',
            modalIDel: 'ModDelete',
            modalIArch: 'ModArchive',
            modalIDTsk: 'modalIDTsk',
            modalIMoveTo: 'ModMoveTo',
            menuTop: {
                user: false,
                task: true,
                roles: true
            },
            projectUsers: [],
            datUpdateStatus: {
                id: 0,
                title: '',
                description: '',
                project_id: '',
                weight: 0,
                color: '#000000',
                errorText: ''
            },
            datUpdateTask: {
                statusName: '',
                id: 0,
                title: '',
                description: '',
                status_id: '',
                position: '',
                weight: 0,
                color: '#000000',
                errorText: '',
                date_create: 0,
                date_planned_end: '',
                date_planned_start: '',
                author: {},
                performer: [],
                controller: [],
                files: [],
                priority: 0,
                imageFile: ''
            },    
            modalRole: {
                id: 'modalRoleLis',
                size: 'modal-xl',
                title: this.$t("UI.projectRoles"),
                isProject: true
            },        
            lSat: [],
            tasks: [],
            files: [],
            archive: [],
            modalTitle: '',
            modalBtnOk: '',
            colors: [ '#C084FC', '#A1A1A1', '#60A5FA', '#4ADE80', '#FACC15', '#FB923C', '#DE4A85', '#2563EB' ],
            priorityValues,
            archiveType: {
                type: 0,
                id: 0,
                title: ''
            },
            deleteType: {
                type: 0,
                id: 0,
                title: ''
            },
            taskToMoveID: 0,
            eventStatusId: 0,
            eventTasks: [],
            activeTabs: {
                task: "params",
                subTask: "params"
            },
            commentsList: []
        }
    },
    beforeMount() {
        this.getPrimaryInfo()
        this.loadUsers()
    }, 
    computed: {      
        selectedPriority: {
            get() {
                return this.priorityValues.find(option => option.value === this.datUpdateTask.priority) || null
            },
            set(option) {
                this.datUpdateTask.priority = option ? option.value : null
            }
        }
    },   
    methods: {
        ...mapActions('dashboard', ['listComments']),
        ...mapGetters('dashboard', ['getListComments']),         
        ...mapActions('company', { companyInfo : 'info'}),
        ...mapGetters('company', { getCompanyInfo : 'getInfo'}),        
        ...mapActions('project', ['info', 'delete', 'listUsers']),
        ...mapGetters('project', ['getInfo', 'getListUsers']),
        ...mapActions('board', ['list', 'updatSt', 'delSt', 'updatTsk', 'updatTskDate', 'clearTskDate', 'delTsk', 'archTsk', 'listPerformers', 'assignPerformer', 'detachPerformer', 'listControllers', 'assignController', 'detachController', 'uploadFiles', 'deleteFile', 'sortAll']),
        ...mapGetters('board', ['getList']),  
        ...mapActions('user', ['userInfo']),
        
        localeDate, 
        nameColor,
        switchDashboardMode(mode) {
            this.dashboardMode = mode
        },
        disabledBeforeToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            return date < today;
        },        
        async closeTaskModal() {
            this.$refs.TskModal.hide()
            console.log('***** TASK MODAL CLOSED!!! *****')
        },  
        createNewTask() {
            return {
                statusName: '',
                id: 0,
                title: '',
                description: '',
                status_id: '',
                position: '',
                weight: 0,
                color: '#000000',
                errorText: '',
                date_create: 0,
                date_planned_end: '',
                date_planned_start: '',
                author: {},
                performer: [],
                controller: [],
                files: [],
                priority: 0,
                imageFile: ''
            }
        },
        getPreparedTask(task) {
            const priorityObj = this.priorityValues.find(option => option.value === task.priority);
            return {
                ...task,
                priorityObj
            };
        }, 
        async getPrimaryInfo() {
            // Project
            await this.info(this.$route.params.id)
            this.project = this.getInfo()

            this.prInfo.title = this.project.name
            this.prInfo.id = this.$route.params.id

            this.updTstts()
            this.datUpdateStatus.project_id = this.$route.params.id
            
            // Company
            await this.companyInfo(this.project.company_id)
            this.company = this.getCompanyInfo()

            // Comments
            await this.listComments(this.$route.params.id)
            this.commentsList = this.getListComments()
        },
        async loadUsers() {
           await this.listUsers(this.$route.params.id)
           this.projectUsers = this.getListUsers()
           this.prInfo.activeUser = await this.userInfo()
        },         
        showMod(id) {
            //this.datUpdateStatus.id = id
            if (id > 0) {
                this.modalTitle = this.$t("UI.changeStatus")
                this.modalBtnOk = this.$t("UI.change")
                this.listStat.forEach(element => {
                    if (id == element.id) {
                        this.datUpdateStatus = {... element}
                    }
                })
            } else {
                this.modalTitle = this.$t("UI.addStatus")
                this.modalBtnOk = this.$t("UI.add")
                this.datUpdateStatus = {... {
                    id: 0, title: '', description: '', project_id: this.$route.params.id, weight: 0, color: '#000000'
                } }
            }

            this.$refs.BsModal.shows()
        },
        showModTask(id, status, taskActiveTab="params", activeSubTaskID=null) {
            //this.datUpdateTask.id = id
            let stID = 0

            if (id > 0) {
                this.modalTitle = this.$t("UI.task.change")
                this.modalBtnOk = this.$t("UI.change")

                for (const st in this.tasks) {
                    this.tasks[st].forEach(elementT => {
                        if (id == elementT.id) {
                            this.datUpdateTask = { ...elementT };
                            stID = st
                        }
                    });
                }
            } else {
                this.modalTitle = this.$t("UI.addTask")
                this.modalBtnOk = this.$t("UI.add")

                this.datUpdateTask = this.createNewTask()
            }
            
            this.listStat.forEach(elementS => {
                if (stID == elementS.id) {
                    this.datUpdateTask.statusName = elementS.title
                    this.datUpdateTask.status_id  = elementS.id

                    this.datUpdateStatus = {... elementS}
                }
            })

            this.$refs.TskModal.shows(taskActiveTab, activeSubTaskID)
        },       
        async showDel(type, id) {
            this.deleteType.type = type
            this.deleteType.id = id

            if (type == 1) {
                this.deleteType.title = this.$t("UI.deleteCompany")
            } else if (type == 2) {
                this.deleteType.title = this.$t("UI.deleteStatus")
            } else if (type == 3) {
                this.deleteType.title = this.$t("UI.task.delete")
            }

            const confirmed = await confirm(this.deleteType.title, this.$t("UI.confirmDelete"), this.$t("UI.ok"), this.$t("UI.cancel"))
            if (!confirmed) return

            this.closeTaskModal()
            this.deleteAll()
        },
        deleteAll() {
            if (this.deleteType.type == 1) {
                this.deleteProject()
            } else if (this.deleteType.type == 2) {
                this.deleteStatus()
            } else if (this.deleteType.type == 3) {
                this.deleteTask()
            }
        },        
        async showArch(type, id) {
            this.archiveType.type = type
            this.archiveType.id = id

            if (type == 1) {
                this.archiveType.title = this.$t("UI.archiveCompany")
            } else if (type == 2) {
                this.archiveType.title = this.$t("UI.archiveStatus")
            } else if (type == 3) {
                this.archiveType.title = this.$t("UI.task.archive")
            }

            const confirmed = await confirm(this.archiveType.title, this.$t("UI.confirmArchive"), this.$t("UI.ok"), this.$t("UI.cancel"))
            if (!confirmed) return
            
            this.closeTaskModal()
            this.archiveAll()
        },
        archiveAll() {
            if (this.archiveType.type == 1) {
                this.archiveProject()
            } else if (this.archiveType.type == 2) {
                this.archiveStatus()
            } else if (this.archiveType.type == 3) {
                this.archiveTask()
            }
        },        
        showMoveTo(taskId) {
            this.taskToMoveID = taskId
            this.$refs.MoveToModal.shows()
        },                          
        async updTstts() {
            await this.list(this.project.id)
            let allStatus = await this.getList()
            this.tasks = {};
            this.listStat = [];

            if (allStatus.length > 0) {
                let indx = 0
                allStatus.forEach(element => {
                    let ts = [];
                    let indxT = 0;
                    element.tasks.forEach(elementTs => {
                        ts[indxT] = elementTs
                        indxT++

                        if (this.datUpdateTask.id == elementTs.id) {
                            this.datUpdateTask = elementTs
                        }                        
                    });

                    this.tasks[element.id] = ts

                    this.listStat[indx] = element
                    indx++
                })
            }
        },
        chColor(val) {
            this.datUpdateStatus.color = val
        },
        chColorTsk(val) {
            this.datUpdateTask.color = val
        },               
        updateParagraph(text) {
            console.log(text)
        },
        async deleteProject() {
            await this.delete(this.projectInfo.id)
            this.$router.push({ name: 'home' })
        },
        async deleteStatus() {
            await this.delSt(this.deleteType.id)
            this.updTstts()
        },
        async deleteTask() {
            await this.delTsk(this.deleteType.id)
            this.updTstts()
        },
        async archiveTask() {
            await this.archTsk(this.archiveType.id)
            this.updTstts()
        },
        async updateStatus() {
            await this.updatSt(this.datUpdateStatus)

            this.updTstts()
            this.$refs.BsModal.hide()
        },     
        updateCurrentTaskData() {
            //
        },    
        moveTo(statusId) {
            let arr = [];
            let indx = 0;

            this.listStat.forEach(element => {
                let arrTsk = []
                let indxTsk = 0
                if (statusId == element.id) {
                    arrTsk[indxTsk] = this.taskToMoveID
                    indxTsk++
                }
                this.tasks[element.id].forEach(elementTsk => {
                    if (this.taskToMoveID != elementTsk.id) {
                        arrTsk[indxTsk] = elementTsk.id
                        indxTsk++
                    }
                })
                arr[indx] = { 'id': element.id, 'task': arrTsk }
                indx++
            })

            this.taskToMoveID = 0
            let jsonStat = JSON.stringify(arr)
            this.sortAll(jsonStat)

            this.updTstts()
            this.$refs.MoveToModal.hide()            
        },     
        onEnd(e) {
            // console.log(this.tasks)
            let arr = [];
            let indx = 0;
            this.listStat.forEach(element => {
                let arrTsk = []
                let indxTsk = 0
                this.tasks[element.id].forEach(elementTsk => {
                    arrTsk[indxTsk] = elementTsk.id
                    indxTsk++
                });
                arr[indx] = { 'id': element.id, 'task': arrTsk }

                indx++
            });

            let jsonStat = JSON.stringify(arr)
            this.sortAll(jsonStat)
        },
        showRole() {
            this.modalRole.isProject = true
            this.modalRole.title = this.$t("UI.projectRoles")
            this.$refs.RoleModal.shows()
        },
        showModStatRole() {
            this.modalRole.isProject = false
            this.modalRole.title = this.$t("UI.statusRoles")
            this.$refs.RoleModal.shows()
        }, 
        showMoveStatus() {
            this.$refs.MoveStatusModal.shows()
        },       
        switchCommandTabsMode() {
            this.commandTabsMode = this.commandTabsMode == 'collapsed' ? 'expanded' : 'collapsed'
        },
        requestProjectEdit() {
            let selectedProject = { ... this.project }
            this.$refs.projectModal.shows(this.company.id, selectedProject.id)
        },
        doScrollTop(statusId) {
            const simpleBarInstance = this.$refs[`scrollbarRef${statusId}`][0].SimpleBar
            simpleBarInstance.getScrollElement().scrollTop = 0  
        },
        handleDrag(e, statusId) {
            const container = $refs[`scrollbarRef${statusId}`]?.[0]?.$el || 
                                $refs[`scrollbarRef${statusId}`]?.[0];
            
            if (!container) return;

            const { top, bottom } = container.getBoundingClientRect();
            const { clientY } = e.originalEvent;
            const SCROLL_THRESHOLD = 50;
            const SCROLL_SPEED = 15;

            // Скролл вверх
            if (clientY < top + SCROLL_THRESHOLD) {
                container.scrollTop -= SCROLL_SPEED;
            } 
            // Скролл вниз
            else if (clientY > bottom - SCROLL_THRESHOLD) {
                container.scrollTop += SCROLL_SPEED;
            }
        }          
    }

}
</script>

<style>
    .over-bg {
        background-color: rgba(0, 58, 92, 0.616);
    }

    .btn svg {
        fill: #747373;
    }
</style>